var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorWithOrangeCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8251)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8251",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.1182C38.2678 49.1182 49.0234 38.3632 49.0234 25.0962C49.0234 11.8292 38.2678 1.07422 25 1.07422C11.7322 1.07422 0.976562 11.8292 0.976562 25.0962C0.976562 38.3632 11.7322 49.1182 25 49.1182Z",
    fill: "#CE720F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5596 36.0509C22.5225 34.6973 23.5059 33.6035 25.1011 33.6035C26.5107 33.6035 27.4937 34.6973 27.4937 36.0509C27.4937 37.4601 26.4549 38.5354 25.0079 38.5354C23.5059 38.5352 22.5596 37.4414 22.5596 36.0509Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9971 10.9648V29.5613L23.0273 29.4316V10.9648H26.9971Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWithOrangeCircle);
export default __webpack_public_path__ + "static/media/error_with_orange_circle.dbc7fd1aefad60d6f6970d004b227935.svg";
export { ForwardRef as ReactComponent };